import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';


interface Role {
  userroleid: number;
  userrolename: string;
}

interface RoleState {
  roles: Role[];
  loading: boolean;
  error: string | null;
}

const initialState: RoleState = {
  roles: [],
  loading: false,
  error: null,
};

export const fetchRoles = createAsyncThunk<Role[], { userId: string; sectorId: number }>(
  'roles/fetchRoles',
  async ({ userId, sectorId }) => {
    const response = await axiosInstance.post(`${BASE_URL}/api/v1/Role/GetRoleByUserIdSectorId`, {

      userid: userId,
      sectorid: sectorId,
    });
    return response.data as Role[]; // Cast response.data to Role[]
  }
);

const roleSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload; // Save the fetched roles
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || null; // Provide fallback to null
      });
  },
});

export default roleSlice.reducer;
